class window.SitesList
  constructor: ->
    @openButton = $('.dropdown-list-sites-js')
    @closeButton = $('.sites-list__arrow-close-js')
    @mainContainer = $('.sites-list-desktop__wrapper-js')

    @openButtonInit()
    @closeButtonInit()


  openButtonInit: ->
    self = this

    $(self.openButton).click ->
      $(self.mainContainer).addClass('sites-list-desktop__wrapper--active')


  closeButtonInit: ->
    self = this

    $(self.closeButton).click ->
      $(self.mainContainer).removeClass('sites-list-desktop__wrapper--active')
      $(self.openButton).removeClass('active')



// WEBPACK FOOTER //
// ./assets/javascripts/app/sites_list.coffee